export enum CallType {
    INCOMING = 1,
    INCOMING_STRING = 'incoming',
    OUTGOING = 2,
    OUTGOING_STRING = 'outgoing',
}
